import { AGG_LEVEL, AGG_LEVEL_ITEM_KEY, SELECTOR_TYPE } from "./constants";
import { DataTransformations } from "../../../utils/data_transformations";
import { ROW_TYPE } from "../../core/_utils/constants";
const servicesOrder = [
  "Lowerreg",
  "Raisereg",
  "Lower6sec",
  "Raise6sec",
  "Lower60sec",
  "Raise60sec",
  "Lower5min",
  "Raise5min"
];

class ReportsDataTransformations {
  //sort array of services into a given order
  static sortServices(services) {
    services.sort((a, b) => {
      return (
        servicesOrder.indexOf(a.fcas_service_name) >
        servicesOrder.indexOf(b.fcas_service_name)
      );
    });
    return services;
  }

  //get hierarchicalData from raw object flat response from query
  //optional filter by services
  // static getHierarchicalData(rawData, services) {
  //   let hierarchicalData = [...rawData]
  //     .filter(i => {
  //       let match = true;
  //       if (services) {
  //         //filter by services
  //         match = false;
  //         services.forEach(s => {
  //           if (!match) match = i["fcas_services"].indexOf(s.value) >= 0;
  //         });
  //       }
  //       return match;
  //     })
  //     .sort((a, b) =>
  //       `${a.regionid}${a.portfolioid}${a.stationid}${
  //         a.duid_name
  //       }`.localeCompare(
  //         `${b.regionid}${b.portfolioid}${b.stationid}${b.duid_name}`
  //       )
  //     )
  //     .reduce((acc, item) => {
  //       const regionIdx = acc.findIndex(
  //         ei => ei["regionid"] === item["regionid"]
  //       );
  //       if (regionIdx === -1) {
  //         acc.push({
  //           regionid: item["regionid"],
  //           portfolios: [
  //             {
  //               portfolioid: item["portfolioid"],
  //               stations: [
  //                 {
  //                   stationid: item["stationid"],
  //                   duids: [
  //                     {
  //                       duid_name: item["duid_name"],
  //                       fcas_services: item["fcas_services"],
  //                       fuel_cost: item["fuel_cost"],
  //                       fuel_type: item["fuel_type"]
  //                     }
  //                   ]
  //                 }
  //               ]
  //             }
  //           ]
  //         });
  //       } else {
  //         const portfolioIdx = acc[regionIdx].portfolios.findIndex(
  //           ei => ei.portfolioid === item["portfolioid"]
  //         );
  //         if (portfolioIdx === -1) {
  //           acc[regionIdx].portfolios.push({
  //             portfolioid: item["portfolioid"],
  //             stations: [
  //               {
  //                 stationid: item["stationid"],
  //                 duids: [
  //                   {
  //                     duid_name: item["duid_name"],
  //                     fcas_services: item["fcas_services"],
  //                     fuel_cost: item["fuel_cost"],
  //                     fuel_type: item["fuel_type"]
  //                   }
  //                 ]
  //               }
  //             ]
  //           });
  //         } else {
  //           const stationIdx = acc[regionIdx].portfolios[
  //             portfolioIdx
  //           ].stations.findIndex(ei => ei["stationid"] === item["stationid"]);
  //           if (stationIdx === -1) {
  //             acc[regionIdx].portfolios[portfolioIdx].stations.push({
  //               stationid: item["stationid"],
  //               duids: [
  //                 {
  //                   duid_name: item["duid_name"],
  //                   fcas_services: item["fcas_services"],
  //                   fuel_cost: item["fuel_cost"],
  //                   fuel_type: item["fuel_type"]
  //                 }
  //               ]
  //             });
  //           } else {
  //             acc[regionIdx].portfolios[portfolioIdx].stations[
  //               stationIdx
  //             ].duids.push({
  //               duid_name: item["duid_name"],
  //               fcas_services: item["fcas_services"],
  //               fuel_cost: item["fuel_cost"],
  //               fuel_type: item["fuel_type"]
  //             });
  //           }
  //         }
  //       }
  //       return acc;
  //     }, []);
  //   return hierarchicalData;
  // }

  //toggle item from  deselected array of items
  static toggleDeselectedItem(currentDeselectedItems, toggleItemValue) {
    const idx = currentDeselectedItems.indexOf(toggleItemValue);
    if (idx >= 0)
      //if item already in array of deselectedItem
      currentDeselectedItems.splice(idx, 1); //remove item
    else currentDeselectedItems.push(toggleItemValue); //add item to array
    return currentDeselectedItems;
  }

  //check if item is checked if it is not part of deselecteditems array.
  // static isChecked(deselectedItems, item) {
  //   if (deselectedItems) {
  //     for (let i = 0; i < deselectedItems.length; i++)
  //       if (deselectedItems[i] === item) return false;
  //   }
  //   return true;
  // }

  //get data, processed into structure used by the selector checkbox component
  //object with properties as text, value and isChecked
  static getDataForSelectors(
    selectorType,
    rawData,
    deselectedItems,
    checkedServices
  ) {
    let data = [];
    if (!rawData) return data;

    //const deselectedItemsStr = deselectedItems ? deselectedItems.join(",") : ""; this is not safe, especially when using str to find a match, if one item is substring of another item like revenue and market_share_revenue

    switch (selectorType) {
      case SELECTOR_TYPE.SERVICES:
        rawData.forEach(item => {
          data.push({
            text: item["fcas_service_name"],
            value: item["fcas_service_name"],
            isChecked: DataTransformations.isChecked(
              deselectedItems,
              item["fcas_service_name"]
            )
          });
        });
        break;
      case SELECTOR_TYPE.OBJECTS:
        rawData.forEach(item => {
          const value = item["element_no"];
          const text = `${item["regionid"]} \\ ${item["portfolioid"]} \\ ${
            item["stationid"]
          } \\ ${item["duid_name"]}`;
          data.push({
            ...item,
            text,
            value,
            isChecked: DataTransformations.isChecked(deselectedItems, value)
          });
        });
        break;
      case SELECTOR_TYPE.VARIABLES:
        rawData.forEach(item => {
          data.push({
            ...item,
            text: item["text"],
            value: item["value"],
            isChecked: DataTransformations.isChecked(
              deselectedItems,
              item["value"]
            ),
            disabled: this.isVariableDisabled(item, checkedServices)
          });
        });
        break;
      default:
        console.error(
          "Data transformation for selectors not defined for selector type:",
          selectorType
        );
    }
    return data;
  }

  static isVariableDisabled(item, checkedServices) {
    let match = false;
    if (item.services) {
      item.services.split(",").forEach(s => {
        checkedServices.forEach(cs => {
          if (cs.value.toLowerCase() === s.toLowerCase()) match = true;
        });
      });
    }

    return !match;
  }

  //get filtered variables based which selected services are supported by variable
  static getFilteredVariables(
    processedVariables,
    rawVariables,
    checkedServices
  ) {
    let filteredVariables = [];
    processedVariables.forEach(pv => {
      const services = rawVariables.filter(rv => rv.value === pv.value)[0]
        .services;
      //console.log('services', pv, services);
      if (services) {
        //filter by services
        checkedServices.forEach(fs => {
          if (
            services.indexOf(fs.value.toLowerCase()) >= 0 &&
            filteredVariables.indexOf(pv) < 0
          )
            filteredVariables.push(pv);
        });
      }
    });
    return filteredVariables;
  }

  //bool if should expect data for combination of service and variable.
  static _expectDataForServiceVariable(
    rawVariables,
    variableValue,
    serviceValue
  ) {
    return (
      rawVariables
        .filter(rv => rv.value === variableValue)[0]
        .services.indexOf(serviceValue.toLowerCase()) >= 0
    );
  }

  //get csv format data from object data for report
  static getCsvDataFromJsonReportObject(objectData) {
    if (!objectData || objectData.length < 1) return;
    let csvData = [];
    const headerData = this.getTableReportHeaderData(objectData);
    if (headerData) {
      const dtLength = headerData.length;
      csvData.push(["Object"].concat(headerData));
      objectData.forEach(d => {
        let row = [];
        if (d.rowType === "object") {
          row.push(`${d.text} (${d.duids})`); //col 1
          //no other data
        } else {
          row.push(`${d.text} (${d.units})`); //col 1
          //add other report data
          if (d.expect_data) {
            if (objectData[d.refRowIndex].data) {
              Object.keys(objectData[d.refRowIndex].data).forEach(dt => {
                row.push(objectData[d.refRowIndex].data[dt][d.refColKey]);
              });
            }
          } else {
            for (let i = 0; i < dtLength; i++) row.push("N/A");
          }
        }

        csvData.push(row);
      });
    }
    return csvData;
  }

  //get table header datetime data from object data
  static getTableReportHeaderData(data) {
    let headerData = null;
    if (data) {
      //get data for header and number of columns from  first object that as report data
      for (let i = 0; i < data.length; i++) {
        if (data[i] && data[i].data && Object.keys(data[i].data).length > 0) {
          headerData = Object.keys(data[i].data);
          break;
        }
      }
    }
    return headerData;
  }

  //get flat data from heirarchial objects based on aggLevel, filtering out deselectedItems
  static getObjectDataForReport(
    objects,
    aggLevel,
    selectedItems,
    services,
    variables,
    reportData,
    rawVariables
  ) {
    let data = [];
    // console.log(
    //   "getobjectdataforreport",
    //   objects,
    //   aggLevel,
    //   selectedItems,
    //   services,
    //   variables,
    //   reportData,
    //   rawVariables
    // );
    if (!objects || !aggLevel) return data;

    let startingRowIndex = 0;

    objects.forEach(item => {
      const text = this._getItemText(aggLevel, item);
      if (
        data.filter(item => this._getItemText(aggLevel, item) === text).length <
        1
      ) {
        //if not already added
        const childItems = this._getChildItems(aggLevel, item, objects);
        const elements = childItems.map(i => i.element_no);
        const rowCount = data.push({
          rowType: ROW_TYPE.OBJECT,
          text: text, //this._getObjectName(regionid),
          elements: elements,
          duids: childItems.map(i => i.duid_name),
          data: reportData && reportData[elements.join(",")],
          regionid: item.regionid,
          portfolioid: item.portfolioid,
          stationid: item.stationid,
          duid_name: item.duid_name,
          fuel_cost: item.fuel_cost,
          fuel_type: item.fuel_type
        });
        const refRowIndex = startingRowIndex + rowCount - 1;

        if (services && variables) {
          services.forEach(sv => {
            variables.forEach(v => {
              data.push({
                rowType: ROW_TYPE.VARIABLE,
                expect_data: this._expectDataForServiceVariable(
                  rawVariables,
                  v.value,
                  sv.value
                ),
                text: `${
                  v.text === "Average Energy Price"
                    ? v.text
                    : `${sv.text} ${v.text}`
                }`,
                refRowIndex: refRowIndex,
                refColKey: `${v.value}_${sv.value.toLowerCase()}`,
                units: v.units,
                decimalPlaces: v.decimalPlaces,
                axisType: v.axisType,
                description: v.description
              });
            });
          });
        }
      }
    });
    return data;
  }

  static _getItemText(aggLevel, item) {
    return aggLevel === AGG_LEVEL.PORTFOLIOS
      ? `${item.portfolioid} (${item.regionid})`
      : item[AGG_LEVEL_ITEM_KEY[aggLevel]];
  }

  static _getChildItems(aggLevel, item, objects) {
    if (!item || !objects) return [];

    if (aggLevel === AGG_LEVEL.PORTFOLIOS) {
      return objects.filter(
        o =>
          o["regionid"] === item["regionid"] &&
          o["portfolioid"] === item["portfolioid"]
      );
    } else {
      const key = AGG_LEVEL_ITEM_KEY[aggLevel];
      return objects.filter(o => o[key] === item[key]);
    }
  }
}

export default ReportsDataTransformations;



// WEBPACK FOOTER //
// ./src/views/reports/_utils/reportsDataTransformations.js